export const SCROLL_TO_ABOUT = 'about';
export const SCROLL_TO_FEATURES = 'features';
export const SCROLL_TO_ROADMAP = 'roadmap';
export const SCROLL_TO_COLLAB = 'collab';
export const SCROLL_TO_CONTACTS = 'contacts';
export const SCROLL_TO_LIME = 'lime';
